import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 2V4V15C1 15.5523 1.44772 16 2 16H20C20.5523 16 21 15.5523 21 15V5C21 4.44772 20.5523 4 20 4H10.118C9.73926 4 9.393 3.786 9.22361 3.44721L8.27639 1.55279C8.107 1.214 7.76074 1 7.38197 1H2C1.44772 1 1 1.44772 1 2Z",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }